<div class="furnish-container">

  <ng-container *ngIf="!loader">
    <div class="furnish-container-body">
      <div class="left-side">
        <div class="item" [ngClass]="furnish.active?'active':''"
          *ngFor="let furnish of furnishArr; let i = index" 
          (click)="selectFurnish(i)">
          {{furnish.title}}
        </div>
      </div>
      <div class="right-side">
        <div class="furnishes-checkbox">
          <div class="item" *ngFor="let s of selectedFurnishList; let i = index" >
            <label class="container-checkbox">
              {{s.title}}
              <input type="checkbox" [(ngModel)]="s.checked" (change)="saveSelectedValues(s)">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div class="selected-furnishes">
          <ng-container *ngFor="let type of returnedData">
            <div class="li">
              {{type?.title}}
              <span class="item-close" (click)="deleteFurnishType(type)"></span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="furnish-container-footer">
      <div class="btn btn-apply" (click)="confirm()">Подтвердить</div>
      <div class="btn btn-cancel" (click)="cancelModal()">Отменить</div>
    </div>
  </ng-container>

  <ng-container *ngIf="loader">
    <div class="loading"></div>
  </ng-container>

</div>